export const regex = "^[a-zA-Z'][a-zA-Z\\s'\\-]*$";
export default regex;
